import type { ReactNode } from "react";

interface NoDataProps {
  title: string;
  description: string;
  children?: ReactNode;
}
export default function NoData({
  title,
  description,
  children,
}: Readonly<NoDataProps>) {
  return (
    <div className="w-full flex-1 gap-1 flex flex-col justify-center items-center text-center">
      <h2 className="text-heading-quiet font-semibold text-2xl">{title}</h2>
      <p className="text-body-quiet text-base font-normal mb-6">
        {description}
      </p>
      {children}
    </div>
  );
}
